import { Theme } from "@mui/material/styles";
import { SystemStyleObject, alpha } from "@mui/system";

const newStoreDetailsStyles = {
  container: (theme: Theme): SystemStyleObject<Theme> => ({
    position: "relative",
    zIndex: 99,
    backgroundColor: alpha(theme.palette.background.default, 0.6),
    pt: 3,
    pb: 3,
    mb: 4,
  }),
};

export default newStoreDetailsStyles;
